import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { Analytics } from '@vercel/analytics/react';
import { ShopifyProvider } from './contexts/ShopifyContext';
import Header from './components/common/Header';
import CartSidebar from './components/cart/CartSidebar';
import './styles/global.css';

const Landing = lazy(() => import('./pages/Landing'));
const Home = lazy(() => import('./pages/Home'));
const ProductDetail = lazy(() => import('./pages/ProductDetail'));
const Shop = lazy(() => import('./pages/Shop'));
const Account = lazy(() => import('./pages/Account'));
const About = lazy(() => import('./pages/About'));
const SizeGuide = lazy(() => import('./pages/SizeGuide'));

function AppContent() {
  const location = useLocation();
  const isLandingPage = location.pathname === '/' || location.pathname === '/landing';

  return (
    <div className="App">
      {!isLandingPage && <Header />}
      {!isLandingPage && <CartSidebar />}
      <main>
        <Suspense fallback={<div className="loading">Loading...</div>}>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/landing" element={<Landing />} />
            <Route path="/home" element={<Home />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/shop/:category" element={<Shop />} />
            <Route path="/product/:slug" element={<ProductDetail />} />
            <Route path="/new-arrivals" element={<Shop />} />
            <Route path="/account" element={<Account />} />
            <Route path="/about" element={<About />} />
            <Route path="/size-guide" element={<SizeGuide />} />
          </Routes>
        </Suspense>
      </main>
    </div>
  );
}

function App() {
  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID || ''}>
      <ShopifyProvider>
        <Router>
          <AppContent />
          <Analytics />
        </Router>
      </ShopifyProvider>
    </GoogleOAuthProvider>
  );
}

export default App;
